var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length)?_c('div',_vm._l((_vm.errors),function(error){return _c('div',{key:error,staticClass:"error-notification"},[_c('WarningSvg'),_c('ion-text',[_vm._v(_vm._s(error))])],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }